import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "filter-form" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("已通过")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已驳回")
const _hoisted_6 = {
  key: 0,
  class: "dot-status orange"
}
const _hoisted_7 = {
  key: 1,
  class: "dot-status green"
}
const _hoisted_8 = {
  key: 2,
  class: "dot-status red"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查看")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_review = _resolveComponent("review")
  const _component_detail = _resolveComponent("detail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: _ctx.filter,
        layout: "inline",
        labelAlign: "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                value: _ctx.filter.corpName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.corpName = $event)),
                valueModifiers: { trim: true },
                placeholder: "请输入企业名称",
                "allow-clear": true,
                onSearch: _ctx.fetchList
              }, null, 8, ["value", "onSearch"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.appId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.appId = $event)),
                placeholder: "请选择应用名称",
                onChange: _ctx.fetchList,
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apps, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.status,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.status = $event)),
                placeholder: "请选择审核状态",
                onChange: _ctx.fetchList,
                allowClear: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.data,
      columns: _ctx.columns,
      "row-key": (record) => record.id,
      pagination: false
    }, {
      applyTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(record.applyTime)), 1)
      ]),
      status: _withCtx(({ record }) => [
        (record.status === 0)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(record.statusDesc), 1))
          : _createCommentVNode("", true),
        (record.status === 1)
          ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(record.statusDesc), 1))
          : _createCommentVNode("", true),
        (record.status === 2)
          ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(record.statusDesc), 1))
          : _createCommentVNode("", true)
      ]),
      reviewTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(record.reviewTime)), 1)
      ]),
      operate: _withCtx(({ record }) => [
        (record.status === 0)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: ($event: any) => (_ctx.openReview(record))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "link",
              onClick: ($event: any) => (_ctx.toDetail(record))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"]))
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "row-key"]),
    (_ctx.reviewState.visible)
      ? (_openBlock(), _createBlock(_component_review, {
          key: 0,
          onClose: _ctx.handleClose,
          detail: _ctx.reviewState.detail,
          onSuccess: _ctx.fetchList
        }, null, 8, ["onClose", "detail", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.detailState.visible)
      ? (_openBlock(), _createBlock(_component_detail, {
          key: 1,
          detail: _ctx.detailState.detail,
          onClose: _ctx.closeDetail
        }, null, 8, ["detail", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}